import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"display"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translationKey"}},{"kind":"Field","name":{"kind":"Name","value":"entities"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberCreator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloAction","document":TrelloActionDocument}} as const;
export type TrelloActionQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type TrelloActionQuery = (
  { __typename: 'Query' }
  & { action?: Types.Maybe<(
    { __typename: 'Action' }
    & Pick<Types.Action, 'data' | 'id' | 'type'>
    & { display: (
      { __typename: 'Action_Display' }
      & Pick<Types.Action_Display, 'translationKey' | 'entities'>
    ), memberCreator: (
      { __typename: 'Member' }
      & Pick<Types.Member, 'avatarUrl'>
    ) }
  )> }
);




/**
 * __useTrelloActionQuery__
 *
 * To run a query within a React component, call `useTrelloActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrelloActionQuery(baseOptions: Apollo.QueryHookOptions<TrelloActionQuery, TrelloActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrelloActionQuery, TrelloActionQueryVariables>(TrelloActionDocument, options);
      }
export function useTrelloActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrelloActionQuery, TrelloActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrelloActionQuery, TrelloActionQueryVariables>(TrelloActionDocument, options);
        }
export type TrelloActionQueryHookResult = ReturnType<typeof useTrelloActionQuery>;
export type TrelloActionLazyQueryHookResult = ReturnType<typeof useTrelloActionLazyQuery>;
export type TrelloActionQueryResult = Apollo.QueryResult<TrelloActionQuery, TrelloActionQueryVariables>;